import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-14 px-3 bg-brand-dark border-b border-white/10" data-id="element-82">
      <div className="max-w-2xl mx-auto text-center" data-id="element-83">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-18 md:h-18 bg-brand-accent rounded-full mb-4 shadow-[0_0_25px_rgba(212,161,75,0.4)]" data-id="element-84">
          <ShieldCheck className="w-7 h-7 md:w-9 md:h-9 text-brand-dark" data-id="element-85" />
        </div>

        <h2 className="text-xl md:text-4xl font-black mb-4 text-white uppercase tracking-tight leading-tight" data-id="element-86">
          🔒 GARANTÍA{' '}
          <span className="text-brand-accent neon-glow" data-id="element-87">SIN VUELTAS</span>
        </h2>

        <div className="bg-brand-card p-5 md:p-7 rounded-xl border border-white/5 shadow-xl" data-id="element-88">
          <p className="text-base md:text-xl font-bold text-white mb-3" data-id="element-89">
            Probá el Mega Pack sin riesgo.
          </p>
          <p className="text-sm md:text-base text-gray-300 leading-relaxed font-medium" data-id="element-90">
            Tenés{' '}
            <span className="text-brand-accent font-black" data-id="element-91">
              7 días de garantía
            </span>{' '}
            para revisar todo el contenido. Si no te convence, te devolvemos el
            dinero. Sin preguntas, sin demoras.
          </p>
        </div>
      </div>
    </section>;
}